import React from "react";

export default function HeroProfileAdminSection({
  lang,
  heroProfile,
  setHeroProfile,
  saveHeroProfile
}) {
  if (!heroProfile) return null;

  return (
    <section className="section">
      <h2 className="sectionTitle">Hero Profile ({lang})</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          name="title"
          value={heroProfile.heading || ""}
          onChange={e => setHeroProfile({ ...heroProfile, heading: e.target.value })}
          placeholder="Título"
          className="input"
        />
        <input
          name="subtitle"
          value={heroProfile.description || ""}
          onChange={e => setHeroProfile({ ...heroProfile, description: e.target.value })}
          placeholder="Subtítulo"
          className="input"
        />
        <button
          onClick={saveHeroProfile}
          className="button"
          style={{ alignSelf: "flex-start", marginTop: "0.5rem" }}
        >
          Guardar Hero Profile
        </button>
      </div>
    </section>
  );
}